import { render, staticRenderFns } from "./TeacherPanel.vue?vue&type=template&id=1ac073ac&"
import script from "./TeacherPanel.vue?vue&type=script&lang=js&"
export * from "./TeacherPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports